import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Link,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Stack,
    TablePagination,
    Container,
    Slide,
    Grid,
    InputAdornment,
    alpha,
    Button,
    capitalize,
    CircularProgress,
} from '@mui/material';
import {
    ShoppingCart as OrderIcon,
    Search as SearchIcon,
    Receipt as ReceiptIcon
} from '@mui/icons-material';

import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { paymentHistory } from '../../services/api';
import PaymentsIcon from '@mui/icons-material/Payments';

export interface User {
    id: number;
    firstName: string;
    lastName: string;
    deletedAt: boolean;

}

export interface Offer {
    id: number;
    title: string;
    orderId: string;
    status: string;               // You can create enums if needed
    paymentStatus: string;        // Same here – string is okay for now
    buyerId: number;
    userId: number;
}

interface PaymentTransaction {
    id: string;
    orderId: string;
    amount: number;
    type: 'locker_charges' | 'escrow_payment' | 'seller_payment' | 'buyer_refund';
    timestamp: string;
    status: 'completed' | 'pending' | 'failed';
    offerId: string;
    paymentType: string;
    updatedAt: string;
    userId: string;
    user: User;
    offer: Offer;

}


const PaymentTransactions: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [ transactions, setTransactions ] = useState<PaymentTransaction[]>( [] );
    const [ loading, setLoading ] = useState( true );

    

    const [ page, setPage ] = useState( 0 );
    const [ rowsPerPage, setRowsPerPage ] = useState( 10 );
    const [ totalCount, setTotalCount ] = useState( 0 );
    const location = useLocation();
    const filter = location.state?.filter;

    const initialFilter =
        filter === "Locker_Charges" ? "Locker_Charges" : "all";

    const initialStatusFilter =
        filter && filter !== "Locker_Charges" ? filter : "";

    const [ typeFilter, setTypeFilter ] = useState<string>( initialFilter );
    const [ searchTerm, setSearchTerm ] = useState( initialStatusFilter );


    // =======================
    // 🔥 Fetch API Data
    // =======================
    // useEffect( () => {
    //     const fetchData = async () => {
    //         setLoading( true );

    //         try {
    //             const response = await paymentHistory.getPaymentHistory( {
    //                 page: page + 1,
    //                 limit: rowsPerPage,

    //                 paymentType: typeFilter,
    //             } );

    //             setTransactions( response?.data || [] );
    //             setTotalCount( response?.pagination?.total || 0 );
    //         } catch ( error ) {
    //             console.error( "Failed to fetch payment history", error );
    //         } finally {
    //             setLoading( false );
    //         }
    //     };

    //     fetchData();
    // }, [ page, rowsPerPage, searchTerm, typeFilter ] );

    // useEffect( () => {

    //     const fetchData = async () => {
    //         setLoading( true );

    //         try {
    //             const response = await paymentHistory.getPaymentHistory( {
    //                 page: page + 1,
    //                 limit: rowsPerPage,
    //                 search: searchTerm,
    //                 paymentType: typeFilter,
    //             } );
    // 
    //             setTransactions( response?.data || [] );
    //             setTotalCount( response?.pagination?.total || 0 );
    //         } catch ( error ) {
    //             console.error( "Failed to fetch payment history", error );
    //         } finally {
    //             setLoading( false );
    //         }
    //     };
    //  

    //     searchTerm.length >= 3 && fetchData();
    // }, [ searchTerm ] );
    useEffect( () => {
        const fetchData = async () => {
            setLoading( true );
            try {
                const response = await paymentHistory.getPaymentHistory( {
                    page: page + 1,
                    limit: rowsPerPage,
                    search: searchTerm.length >= 3 ? searchTerm : "",
                    paymentType: typeFilter,
                } );

                setTransactions( response?.data || [] );
                setTotalCount( response?.pagination?.total || 0 );
            } catch ( error ) {
                console.error( "Failed to fetch payment history", error );
            } finally {
                setLoading( false );
            }
        };  

        fetchData();
    }, [ page, rowsPerPage, searchTerm, typeFilter ] );




    const getTypeLabel = ( type: string ) => {
        switch ( type ) {
            case 'locker_charges': return t( 'dashboard.metrics.lockerCharges' );
            case 'escrow_payment': return t( 'dashboard.metrics.escrowPayments' );
            case 'seller_payment': return t( 'dashboard.metrics.sellerPayments' );
            case 'buyer_refund': return t( 'dashboard.metrics.buyerRefunds' );
            default: return type;
        }
    };

    const getTypeColor = ( type: string ) => {
        switch ( type ) {
            case 'locker_charges': return 'primary';
            case 'escrow_payment': return 'warning';
            case 'seller_payment': return 'success';
            case 'buyer_refund': return 'error';
            default: return 'default';
        }
    };

    const getStatusColor = ( status: string ) => {
        switch ( status ) {
            case 'REFUND_TO_BUYER': return 'success';
            case 'Completed': return 'success';
            case 'Payment_In_Escrow': return 'warning';
            case 'Pending': return 'error';
            default: return 'default';
        }
    };

    const handleViewPayment = ( transaction: PaymentTransaction ) => {
        navigate( `/payment-history/${ transaction.id }`, {
            state: { transaction },   // ← Send full object
        } );
    };

    const handleChangePage = ( _: unknown, newPage: number ) => setPage( newPage );

    const handleChangeRowsPerPage = ( event: React.ChangeEvent<HTMLInputElement> ) => {
        setRowsPerPage( parseInt( event.target.value, 10 ) );
        setPage( 0 );
    };
    const formatDate = ( dateString: any ) => {
        const date = new Date( dateString );
        return new Intl.DateTimeFormat( 'en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        } ).format( date );
    };



    // const filteredTransactions = transactions.filter( ( transaction ) => {

    //     const id = transaction?.id?.toString().toLowerCase() ?? "";
    //     // const paymentId = transaction?.paymentId?.toLowerCase() ?? "";
    //     const paymentType = transaction?.paymentType?.toLowerCase() ?? "";
    //     const status = transaction?.status?.toLowerCase() ?? "";

    //     const term = searchTerm.toLowerCase();

    //     const matchesSearch =
    //         id.includes( term ) ||
    //         // paymentId.includes( term ) ||
    //         paymentType.includes( term ) ||
    //         status.includes( term );

    //     const matchesType =
    //         typeFilter === "all"
    //         || transaction.paymentType === typeFilter;
    //     return matchesSearch && matchesType;
    // } );


    // const paginatedTransactions = filteredTransactions.slice(
    //     page * rowsPerPage,
    //     page * rowsPerPage + rowsPerPage
    // );
    const paginatedTransactions = transactions;
    if ( loading && transactions.length === 0 ) {
        return (
            <Container maxWidth="lg" sx={ { py: 4 } }>
                <Box sx={ {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    gap: 2
                } }>
                    <CircularProgress size={ 60 } />
                    <Typography variant="h6" color="text.secondary">
                        Loading Transections...
                    </Typography>
                </Box>
            </Container>
        );
    }





    return (
        <Container maxWidth={ false } sx={ { py: 4, width: "100%" } }>
            <Slide direction="down" in={ true } timeout={ 600 }>
                <Box>
                    {/* Header Section */ }
                    <Box sx={ { mb: 4 } }>
                        <Stack direction="row" alignItems="center" spacing={ 2 } sx={ { mb: 2 } }>
                            <Box
                                sx={ {
                                    p: 1.5,
                                    borderRadius: 2,
                                    bgcolor: "primary.main",
                                    color: "white",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                } }
                            >
                                <PaymentsIcon sx={ { fontSize: 28 } } />
                            </Box>

                            <Box>
                                <Typography variant="h4" fontWeight="bold" gutterBottom>
                                    { t( "payments.title" ) }
                                </Typography>

                                <Typography variant="body1" color="text.secondary">
                                    View all user transactions, payments and refunds
                                </Typography>
                            </Box>
                        </Stack>
                        <Box sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 } }>
                            <Chip
                                icon={ <ReceiptIcon /> }
                                label={ `${ totalCount } Transactions` }
                                color="primary"
                                variant="outlined"
                            />
                        </Box>

                        {/* Search + Type Filter */ }
                        <Grid container spacing={ 2 } sx={ { mb: 3 } }>
                            <Grid item xs={ 12 } md={ 6 }>
                                <TextField
                                    fullWidth
                                    placeholder="Search by payment status, title or user name..."
                                    value={ searchTerm }
                                    onChange={ ( e ) => {
                                        setSearchTerm( e.target.value );
                                        setPage( 0 );
                                    } }
                                    InputProps={ {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    } }
                                    sx={ {
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            backgroundColor: 'background.paper',
                                        },
                                    } }
                                />
                            </Grid>

                            <Grid item xs={ 12 } md={ 6 }>
                                <FormControl fullWidth>
                                    <InputLabel>{ t( "payments.type" ) }</InputLabel>
                                    <Select
                                        value={ typeFilter }
                                        label={ t( "payments.type" ) }
                                        onChange={ ( e ) => setTypeFilter( e.target.value ) }
                                    >
                                        <MenuItem value="all">{ t( "common.all" ) }</MenuItem>
                                        <MenuItem value="Paid_For_Item">Paid For Item</MenuItem>
                                        {/* <MenuItem value="REFUND_TO_BUYER">Refund to Buyer</MenuItem>
                                        <MenuItem value="seller_payment">Seller Payments</MenuItem>
                                        <MenuItem value="escrow_payment">Escrow Payments</MenuItem> */}
                                        <MenuItem value="Locker_Charges">Locker Charges</MenuItem>


                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* Table Section */ }
                    <Paper
                        elevation={ 0 }
                        sx={ {
                            borderRadius: 3,
                            border: "1px solid",
                            borderColor: "divider",
                            overflow: "hidden",
                        } }
                    >
                        { paginatedTransactions.length === 0 ? (

                            <Box sx={ {
                                textAlign: 'center',
                                py: 8,
                                color: 'text.secondary'
                            } }>
                                <OrderIcon sx={ { fontSize: 64, mb: 2, opacity: 0.5 } } />
                                <Typography variant="h6" sx={ { mb: 1 } }>
                                    No transactions found
                                </Typography>
                                <Typography variant="body2">
                                    { searchTerm ? "Try different search keywords" : "No payment records available" }
                                </Typography>
                            </Box>
                        ) : (
                            <>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow
                                                sx={ {
                                                    backgroundColor: "primary.main",
                                                    "& th": {
                                                        color: "white",
                                                        fontWeight: 600,
                                                        fontSize: "0.875rem",
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.5px",
                                                    },
                                                } }
                                            >
                                                <TableCell align="center">ID</TableCell>
                                                <TableCell align="center"> Order Title</TableCell>
                                                <TableCell align="left">Payment Type</TableCell>
                                                <TableCell align="center">User</TableCell>
                                                <TableCell align="center">Amount</TableCell>
                                                <TableCell align="center">Date</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            { paginatedTransactions.map( ( transaction ) => (
                                                <TableRow
                                                    key={ transaction.id }
                                                    sx={ {
                                                        "&:hover": {
                                                            backgroundColor: ( theme ) =>
                                                                alpha( theme.palette.primary.main, 0.04 ),
                                                        },
                                                        transition: "background-color 0.2s ease",
                                                    } }
                                                >
                                                    <TableCell align="center">
                                                        <Typography >
                                                            { transaction.id }
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Typography align="center">
                                                            { capitalize( transaction.offer?.title ) ?? "N/A" }

                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell>{ transaction.paymentType }</TableCell>

                                                    <TableCell align='center'>
                                                        <Typography variant="subtitle2" >  { capitalize( transaction?.user?.firstName ) } { capitalize( transaction?.user?.lastName ) } </Typography>
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Typography >${ transaction.amount }</Typography>
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        { formatDate( transaction.updatedAt ) }
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Chip
                                                            label={ t( `${ transaction.status }` ) }
                                                            color={ getStatusColor( transaction.status ) }
                                                            size="small"
                                                            sx={ { fontWeight: 600 } }
                                                        />
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Button
                                                            variant="contained"
                                                            onClick={ () => handleViewPayment( transaction ) }
                                                            color="primary"
                                                            size="small"
                                                            sx={ {
                                                                borderRadius: 2,
                                                                textTransform: "none",
                                                                fontWeight: 600,
                                                            } }
                                                        >
                                                            View
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ) ) }
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <TablePagination
                                    rowsPerPageOptions={ [ 5, 10, 25 ] }
                                    component="div"
                                    count={ totalCount }   // 👈 backend ka total count
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }
                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }
                                />

                            </>
                        ) }
                    </Paper>
                </Box>
            </Slide>
        </Container>
    );

};

export default PaymentTransactions;
